import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../../helpers/rtkquery';

export const claimApi = createApi({
  reducerPath: 'claimApi',
  baseQuery: rtkBaseQuery('/claim'),
  tagTypes: ['Claims', 'Templates', 'Tags', 'Applications', 'Documents'],
  endpoints: (builder) => ({
    getAllClaims: builder.query({
      query: ({ page, rows }) => `/Claim/GetAll?page=${page}&rows=${rows}`,
      providesTags: ['Claims'],
    }),
    getClaimById: builder.query({
      query: ({ id }) => `/Claim/GetById/${id}`,
      // providesTags: (result, error, { id }) => [{ type: 'Claims', id }],
    }),
    getClaimCreator: builder.query({
      query: () => '/Claim/GetClaimCreator',
    }),

    getClaimExecutor: builder.query({
      query: (params) => ({
        url: '/Claim/GetClaimForExecutor/get-claim-executor',
        method: 'GET',
        params,
      }),
    }),

    createClaim: builder.mutation({
      query: (body) => ({
        url: '/Claim/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Claims'],
    }),

    updateClaim: builder.mutation({
      query: ({ claimId, ...params }) => ({
        url: `/Claim/Update/${claimId}`,
        method: 'PUT',
        params,
      }),
      invalidatesTags: ['Claims'],
    }),
    // Comments
    createComment: builder.mutation({
      query: (body) => ({
        url: '/Comment/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Claims', id }, 'Claims'],
    }),
    // Template
    createTemplate: builder.mutation({
      query: (body) => ({
        url: '/Template/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Templates'],
    }),
    getAllTemplates: builder.query({
      query: () => '/Template/GetAll',
      providesTags: ['Templates'],
    }),
    getTemplateById: builder.query({
      query: ({ id }) => `/Template/GetById?id=${id}`,
      // providesTags: (result, error, { id }) => [{ type: 'Templates', id }],
    }),
    // duplicate

    getTemplateDocById: builder.query({
      query: ({ id }) => `/Template/GetById?id=${id}`,
      // providesTags: (result, error, { id }) => [{ type: 'Templates', id }],
    }),

    updateTemplate: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Template/Update?id=${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Templates', id }, 'Templates'],
    }),
    deleteTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `/Template/Delete?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Templates'],
    }),
    sendTemplateToVerify: builder.mutation({
      query: ({ id, staffId }) => ({
        url: `/Template/SendTemplateToVerify?Id=${id}&staffId=${staffId}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
      }),

      invalidatesTags: (result, error, { id }) => [{ type: 'Templates', id }, 'Templates'],
    }),
    verifyTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `/Template/TemplateVerify?id=${id}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Templates', id }, 'Templates'],
    }),
    rejectTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `/Template/TemplateReject?id=${id}`,
        method: 'POST',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Templates', id }, 'Templates'],
    }),
    changeTemplatePublic: builder.mutation({
      query: ({ id, isPublic }) => ({
        url: `/Template/ChangeTemplatePublic/${id}?newPublic=${isPublic}`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Templates', id }, 'Templates'],
    }),
    getPublicTemplates: builder.query({
      query: () => '/Template/GetIsPublicTemplate?isPublic=true',
    }),
    // Tag
    getAllTags: builder.query({
      query: ({ all = true }) => `/Tag/GetAll?all=${all}`,
      providesTags: ['Tags'],
    }),
    //Applications
    getApplicationContent: builder.query({
      query: ({ id }) => `/Application/GetContent?templateId=${id}`,
      // providesTags: (result, error, { id }) => [{ type: 'Application', id }],
    }),
    newContent: builder.mutation({
      query: ({ body }) => ({
        url: `/Application/GetNewContent`,
        method: 'POST',
        body,
      }),
    }),
    getMyApplications: builder.query({
      query: (params) => ({
        url: '/Application/GetUserApplications',
        params,
      }),
      providesTags: ['Applications'],
    }),
    getApplicationById: builder.query({
      query: ({ id }) => '/Application/GetApplicationById?applicationId=' + id,
      keepUnusedDataFor: 0,
    }),
    createTag: builder.mutation({
      query: (body) => ({
        url: '/Tag/Create',
        method: 'POST',
        body,
      }),
      providesTags: ['Tags'],
    }),

    editTag: builder.mutation({
      query: (body) => ({
        url: `/Tag/Edit`,
        method: 'PUT',
        body,
      }),
      providesTags: ['Tags'],
    }),

    deleteTag: builder.mutation({
      query: ({ id }) => ({
        url: `/Tag/Delete?id=${id}`,
        method: 'DELETE',
      }),
      providesTags: ['Tags'],
    }),

    getApprovalApplications: builder.query({
      query: (params) => ({
        url: '/Application/GetApprovalApplications',
        method: 'GET',
        params: {
          approvedApp: params.approvedApp,
          ...params,
        },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getApplicationForExecutor: builder.query({
      query: (params) => ({
        url: '/Application/GetApplicationForExecutor',
        method: 'GET',
        params: {
          ...params,
        },
      }),
    }),

    approveApplication: builder.mutation({
      query: (body) => ({
        url: '/Application/Reject',
        method: 'POST',
        body,
      }),
    }),

    getSignatureById: builder.query({
      query: ({ applicationId }) => `/Application/GetSignature?applicationId=${applicationId}`,
      providesTags: (result, error, { applicationId }) => [{ type: 'Applications', applicationId }],
    }),

    getApplicationToPrint: builder.query({
      query: ({ page, limit, search }) =>
        `/Application/GetApplicationsByCreator?page=${page}&limit=${limit}&search=${search}`,
      providesTags: ['Applications'],
    }),
    createApplication: builder.mutation({
      query: (formData) => ({
        url: '/Application/Create',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Applications'],
    }),
    getAllExecutorTemplate: builder.query({
      query: () => '/ExecutorTemplate/GetAll',
      providesTags: ['ExecutorTemplates'],
    }),
    getExecutorTemplateById: builder.query({
      query: ({ id }) => '/ExecutorTemplate/GetById?categoryId=' + id,
      // providesTags: (result, error, { id }) => [{ type: 'ExecutorTemplates', id }],
    }),
    createExecutorTemplate: builder.mutation({
      query: (body) => ({
        url: '/ExecutorTemplate/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ExecutorTemplates'],
    }),
    updateExecutorTemplate: builder.mutation({
      query: (body) => ({
        url: '/ExecutorTemplate/Update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ExecutorTemplates'],
    }),
    deleteExecutorTemplate: builder.mutation({
      query: (body) => ({
        url: '/ExecutorTemplate/Delete',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: ['ExecutorTemplates'],
    }),
    changeStatusExecutor: builder.mutation({
      query: ({ applicationId }) => ({
        url: `/ExecutorTemplate/ChangeStatusForExecution?applicationId=${applicationId}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, { applicationId }) => [
        { type: 'ExecutorTemplates', applicationId },
      ],
    }),
    getApplicationsDone: builder.query({
      query: () => '/Application/GetApplicationsDone',
      invalidatesTags: ['Application'],
    }),
    addSignature: builder.mutation({
      query: (body) => ({
        url: '/Application/AddSignature',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Applications', id }],
    }),
    getMyUploadedLocalDocuments: builder.query({
      query: () => '/Document/GetMyDocument',
      providesTags: ['Documents'],
    }),
    updateDocument: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/Document/UpdateDocument?documentId=${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Documents'],
    }),
    deleteDocument: builder.mutation({
      query: ({ documentId }) => ({
        url: `/Document/DeleteDocument?documentId=${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Documents'],
    }),
    sendDocumentToApprovers: builder.mutation({
      query: (body) => ({
        url: '/Document/SendDocumentToApprovers',
        method: 'POST',
        body,
      }),
    }),
    getDocumentById: builder.query({
      query: ({ id }) => `/Document/GetDocumentById?documentId=${id}`,
    }),
    getDocumentsDeadLine: builder.query({
      query: () => '/Document/GetDocumentDeadLine',
      providesTags: ['Documents'],
    }),
    approveDocumentDeadLine: builder.mutation({
      query: ({ id }) => ({
        url: `Document/ApproveDocument?documentId=${id}`,
        method: 'POST',
      }),
      // invalidatesTags: ['Documents'],
    }),
    getDocumentVersion: builder.query({
      query: ({ id }) => `/Document/GetDocumentVersion?documentId=${id}`,
    }),
    getDocuments: builder.query({
      query: ({ id }) => `/Document/GetDocuments?status=${id}`,
    }),
    getDocApproversPercent: builder.query({
      query: ({ documentId }) => ({
        url: '/Document/GetDocumentApproversByPercent',
        params: { documentId },
      }),
      providesTags: (result, error, { documentId }) => [
        { type: 'Document-approvers-percent', id: documentId },
      ],
    }),
    getDocumentApproversFilter: builder.query({
      query: ({ documentId, name, docAppStatus, limit = 10, page = 1 }) => ({
        url: '/Document/GetDocumentApproversFilter',
        params: { documentId, name, limit, page, documentApproverStatus: docAppStatus },
      }),
      providesTags: (result, error, { documentId, name }) => [
        {
          type: 'Document-approvers-filter',
          id: documentId,
          name,
        },
      ],
    }),
    getDocumentHistoryById: builder.query({
      query: (params) => ({
        url: `/Document/GetHistoryDocumentById`,
        params,
      }),
    }),
    getDocumentsByStaffId: builder.query({
      query: (params) => ({
        url: `/Document/GetDocumentsByStaffId`,
        params: params,
      }),
    }),
    getTemplateCategories: builder.query({
      query: () => '/TemplateCategory/GetAll?all=true',
      providesTags: ['TemplateCategories'],
    }),

    getTemplateCategoryById: builder.query({
      query: ({ id }) => `/TemplateCategory/GetById?id=${id}`,
      providesTags: (result, error, { id }) => [{ type: 'TemplateCategories', id }],
    }),

    updateTemplateCategory: builder.mutation({
      query: ({ id, body }) => ({
        url: `/TemplateCategory/Update?id=${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['TemplateCategories'],
    }),

    createTemplateCategory: builder.mutation({
      query: (body) => ({
        url: '/TemplateCategory/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TemplateCategories'],
    }),

    deleteTemplateCategory: builder.mutation({
      query: ({ id }) => ({
        url: `/TemplateCategory/Delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TemplateCategories'],
    }),

    // getTemplateCategoryById: builder.query({
    //   query: ({ id }) => `/Template/GetByCategoryId?categoryId=${id}`,
    //   providesTags: (result, error, { id }) => [{ type: 'Template', id }],
    // }),

    getTemplateSubCategoriesById: builder.query({
      query: ({ categoryId }) =>
        `/TemplateSubCategory/GetByTemplateCategoryId?categoryId=${categoryId}`,
      providesTags: (result, error, { categoryId }) => [
        { type: 'TemplateSubCategories', id: categoryId },
      ],
    }),

    getTemplateSubCategoriesParentById: builder.query({
      query: ({ id }) => `/TemplateSubCategory/GetAllParents?templateSubCategoryId=${id}`,
    }),

    getTemplates: builder.query({
      query: ({ categoryId }) => `/TemplateSubCategory/GetByParentId?parentId=${categoryId}`,
      providesTags: ['TemplateSubCategory'],
    }),

    createTemplateSubCategory: builder.mutation({
      query: (body) => ({
        url: '/TemplateSubCategory/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TemplateSubCategory'],
    }),

    updateTemplateSubCategory: builder.mutation({
      query: ({ id, body }) => ({
        url: `/TemplateSubCategory/Update?id=${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['TemplateSubCategory'],
    }),

    deleteTemplateSubCategory: builder.mutation({
      query: (id) => ({
        url: `/TemplateSubCategory/Delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TemplateSubCategory'],
    }),

    getAllCategories: builder.query({
      query: () => '/TemplateSubCategory/GetAll',
      providesTags: ['TemplateSubCategory'],
    }),

    getTemplatesFields: builder.query({
      query: ({ id }) => `/Template/GetTemplatesFields?templateId=${id}`,
      providesTags: (result, error, { id }) => [{ type: 'Template', id }],
    }),

    uploadTemplateFile: builder.mutation({
      query: (formData) => ({
        url: '/Template/UploadFileForFolder',
        method: 'POST',
        body: formData,
      }),
    }),

    getOrderTypes: builder.query({
      query: () => '/Template/GetTypeOfOrders',
    }),

    updateTypeOfOrdersFromHrm: builder.mutation({
      query: () => ({
        url: '/Template/UpdateTypeOfOrdersFromHrm',
        method: 'GET',
      }),
    }),

    getFilterTemplatesCategory: builder.query({
      query: ({ subCategoryId }) => `/Template/GetBySubCategoryId?subCategoryId=${subCategoryId}`,
      providesTags: (result, error, { subCategoryId }) => [{ type: 'Template', id: subCategoryId }],
    }),

    downloadApplicationFile: builder.query({
      query: (path) => ({
        url: `/Application/Download`,
        method: 'GET',
        params: { path },
        responseType: 'arraybuffer',
      }),
    }),

    uploadApplicationFile: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Application/UploadApplicationFile?applicationId=${id}`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const {
  useGetAllClaimsQuery,
  useLazyGetClaimByIdQuery,
  useGetClaimCreatorQuery,
  useGetClaimExecutorQuery,
  useCreateClaimMutation,
  useUpdateClaimMutation,
  useCreateCommentMutation,
  useCreateTemplateMutation,
  useGetAllTemplatesQuery,
  useGetTemplateByIdQuery,
  useLazyGetTemplateDocByIdQuery,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
  useSendTemplateToVerifyMutation,
  useVerifyTemplateMutation,
  useRejectTemplateMutation,
  useChangeTemplatePublicMutation,
  useGetPublicTemplatesQuery,
  useGetAllTagsQuery,
  useGetApprovalApplicationsQuery,
  useGetApplicationForExecutorQuery,
  useApproveApplicationMutation,
  useGetApplicationContentQuery,
  useGetMyApplicationsQuery,
  useGetApplicationByIdQuery,
  useCreateApplicationMutation,
  useLazyGetApplicationByIdQuery,
  useGetApplicationToPrintQuery,
  useCreateTagMutation,
  useEditTagMutation,
  useDeleteTagMutation,
  useLazyGetSignatureByIdQuery,
  useCreateExecutorTemplateMutation,
  useDeleteExecutorTemplateMutation,
  useGetAllExecutorTemplateQuery,
  useUpdateExecutorTemplateMutation,
  useGetExecutorTemplateByIdQuery,
  useChangeStatusExecutorMutation,
  useGetApplicationsDoneQuery,
  useAddSignatureMutation,
  useGetMyUploadedLocalDocumentsQuery,
  useDeleteDocumentMutation,
  useSendDocumentToApproversMutation,
  useGetDocumentByIdQuery,
  useLazyGetDocumentByIdQuery,
  useGetDocumentsDeadLineQuery,
  useApproveDocumentDeadLineMutation,
  useGetDocumentVersionQuery,
  useGetDocumentsQuery,
  useGetDocApproversPercentQuery,
  useGetDocumentApproversFilterQuery,
  useUpdateDocumentMutation,
  useLazyGetDocumentHistoryByIdQuery,
  useGetDocumentsByStaffIdQuery,
  useGetTemplateCategoriesQuery,
  useLazyGetTemplateCategoryByIdQuery,
  useLazyGetTemplatesFieldsQuery,
  useNewContentMutation,
  useLazyGetTemplateSubCategoriesByIdQuery,
  useLazyGetTemplatesQuery,
  useLazyGetFilterTemplatesCategoryQuery,
  useUploadTemplateFileMutation,
  useGetAllCategoriesQuery,
  useUpdateTemplateCategoryMutation,
  useCreateTemplateCategoryMutation,
  useDeleteTemplateCategoryMutation,
  useCreateTemplateSubCategoryMutation,
  useUpdateTemplateSubCategoryMutation,
  useDeleteTemplateSubCategoryMutation,
  useUploadApplicationFileMutation,
  useLazyDownloadApplicationFileQuery,
  useGetOrderTypesQuery,
  useUpdateTypeOfOrdersFromHrmMutation,
  useGetTemplateSubCategoriesParentByIdQuery,
  useLazyGetTemplateSubCategoriesParentByIdQuery,
} = claimApi;
